import React from "react";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import Widget from "./DualList/widget";
import {Button} from "semantic-ui-react";
import Cookies from "js-cookie";
import axios_event from "../../../../../../axios/axios_eventtag";
import axios_tags from "../../../../../../axios/axios_tag";
import apiConfig from "../../../../../../axios/axios_api_services";
import * as common from "../../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";
import * as actionCreator from "../../../../../../store/Action";
import {connect} from "react-redux";

class AddVolunteers extends React.Component {

  state = {
    allVolunteers: [],
    selectedVolunteers: []
  };

  setSelectedVolunteers = (selected_volunteers_list) => {
    this.setState({
      selectedVolunteers: selected_volunteers_list
    })
  };

  componentDidMount() {
    this.loadAllVolunteers();
  }

  loadAllVolunteers = () => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_tags.get(apiConfig.GET_ALL_SYSTEM_VOLUNTEERS(corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let all_volunteers_list = response.data.content;
          let all_volunteers = [];
          all_volunteers_list.map( (volunteer, index) => {
            let volunteer_obj = {
              value: volunteer.userId,
              label: `${ volunteer.fullName } - ${ (volunteer.mobile!==null & volunteer.mobile!=="" & volunteer.mobile!==undefined) ? volunteer.mobile : volunteer.email } ◦ ${
                volunteer.userRoles=="HEAD_USHER" ? "Head Usher"
                : volunteer.userRoles=="USHER" ? "Usher"
                  : "Security" }` };
            all_volunteers.push( volunteer_obj );
          });
          this.setState({
            allVolunteers: all_volunteers
          });
          this.loadSubEventVolunteers(this.props.sub_event_id);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sponsorSendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  loadSubEventVolunteers = (sub_event_id) => {

    if(sub_event_id!==0) {

      this.props.spinnerHandler(true);

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
        "Content-Type": "application/json"
      };

      axios_event.get(apiConfig.GET_SUB_EVENT_VOLUNTEERS({event_id: sub_event_id, corporateId: corporateId}), {headers: headers})
        .then(response => {
          if (response.data.success) {
            let sub_event_volunteers_list = response.data.content;
            let sub_event_volunteers = [];
            sub_event_volunteers_list.map( (volunteer, index) => {
              // let sub_event_volunteer_obj = {
              //   value: volunteer.userId,
              //   label: `${ volunteer.fullName } - ${ volunteer.mobile } ◦ ${
              //     volunteer.userRoles=="HEAD_USHER" ? "Head Usher"
              //       : volunteer.userRoles=="USHER" ? "Usher"
              //       : "Security" }` };
              sub_event_volunteers.push( volunteer.userId );
            });

            this.setState({
              selectedVolunteers: sub_event_volunteers
            })
          } else {
            common.warningAlert(response.data.message, 1)
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sponsorSendToBackEnd_()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }
  };

  sendToBackend = () => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to add these volunteers?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.sendToBackend_();
          break;
        default:
          break;
      }
    });
  };

  sendToBackend_ = () => {
    let req_obj = {
      ushers: this.state.selectedVolunteers
    };

    req_obj = this.state.selectedVolunteers;

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.post(apiConfig.ADD_VOLUNTEERS_TO_THE_SUB_EVENT({sub_event_id: this.props.sub_event_id, corporateId: corporateId}), req_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Volunteers added to the event successfully!", 0);
          this.props.closeModal();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sponsorSendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  //toggle
  toggle = () => {
  };

  render() {
    let { allVolunteers, selectedVolunteers } = this.state;
    console.log("All-Volunteers: ", allVolunteers);
    console.log("Selected-Volunteers: ", selectedVolunteers);
    return(
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Add Volunteers</MDBModalHeader>
          <MDBModalBody>
            <Row style={{paddingLeft: '20px',paddingRight: '20px'}}>
              <Col lg={6} className={'text-center'}><h4>All Volunteers</h4></Col>
              <Col lg={6} className={'text-center'}><h4>Selected Volunteers</h4></Col>
              <Col lg={12}>
                <Widget allvolunteers={ allVolunteers } selectedvolunteers={ selectedVolunteers } setSelectedVolunteers={ this.setSelectedVolunteers } />
              </Col>
              <Col lg={'12'} className={"text-align-path mt-3"} style={{marginBottom: '5px', textAlign: 'end'}}>
                <Button
                  // disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                  className="px-5"
                  onClick={this.sendToBackend}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  current_event: state.eventReducer.current_event,
  current_sub_event_id: state.eventReducer.current_sub_event_id,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddVolunteers);
